import {call, delay, put, takeLatest} from 'redux-saga/effects'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {actions} from './action'
import {actionTypes} from './constants'
import {service} from './service'

function* getReportMenuDataSaga(action: ActionModel) {
  try {
    const params = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getReportMenuData, params)
    yield put(actions.getReportMenuDataSuccess(response?.data?.data))
    yield put(actions.getReportMenuDataFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getReportMenuDataFinish())
  }
}

function* addReportMenuSaga(action: ActionModel) {
  try {
    const response: ResponseModel = yield call(service.addReportMenu, action.payload)
    yield put(actions.addReportMenuSuccess(response.data?.data))
    yield put(actions.addReportMenuFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addReportMenuFinish())
  }
}

function* updateReportMenuSaga(action: any) {
  try {
    const response: ResponseModel = yield call(service.updateReportMenu, action.payload, action.id)
    yield put(actions.updateReportMenuSuccess(response.data?.data))
    yield put(actions.updateReportMenuFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateReportMenuFinish())
  }
}

function* deleteReportMenuSaga(action: ActionModel) {
  try {
    const ids: string[] = action.payload as any
    for (const id of ids) {
      yield call(service.deleteReportMenu, id)
    }
    yield put(actions.deleteReportMenuSuccess({}))
    yield put(actions.deleteReportMenuFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteReportMenuFinish())
  }
}

function* singleEnableReportMenuSaga(action: ActionModel) {
  try {
    const id: string = (action.payload as any)?.data?.id
    yield call(service.singleEnableReportMenu, id)
    yield put(actions.singleEnableReportMenuSuccess(id))
    yield put(actions.singleEnableReportMenuFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleEnableReportMenuFinish())
  }
}

function* singleDisableReportMenuSaga(action: ActionModel) {
  try {
    const id: string = (action.payload as any)?.data?.id
    yield call(service.singleDisableReportMenu, id)
    yield put(actions.singleDisableReportMenuSuccess(id))
    yield put(actions.singleDisableReportMenuFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleDisableReportMenuFinish())
  }
}

function* enableReportMenuSaga(action: ActionModel) {
  try {
    const items: Array<{id: string}> = (action.payload as any)?.data
    for (const item of items) {
      yield call(service.singleEnableReportMenu, item.id)
    }
    yield put(actions.enableReportMenuSuccess({}))
    yield put(actions.enableReportMenuFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.enableReportMenuFinish())
  }
}

function* disableReportMenuSaga(action: ActionModel) {
  try {
    const items: Array<{id: string}> = (action.payload as any)?.data
    for (const item of items) {
      yield call(service.singleDisableReportMenu, item.id)
    }
    yield put(actions.disableReportMenuSuccess({}))
    yield put(actions.disableReportMenuFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.disableReportMenuFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_REPORT_MENU_START, getReportMenuDataSaga)
  yield takeLatest(actionTypes.ADD_REPORT_MENU_START, addReportMenuSaga)
  yield takeLatest(actionTypes.UPDATE_REPORT_MENU_START, updateReportMenuSaga)
  yield takeLatest(actionTypes.DELETE_REPORT_MENU_START, deleteReportMenuSaga)
  yield takeLatest(actionTypes.SINGLE_ENABLE_REPORT_MENU_REQUEST, singleEnableReportMenuSaga)
  yield takeLatest(actionTypes.SINGLE_DISABLE_REPORT_MENU_REQUEST, singleDisableReportMenuSaga)
  yield takeLatest(actionTypes.ENABLE_REPORT_MENU_REQUEST, enableReportMenuSaga)
  yield takeLatest(actionTypes.DISABLE_REPORT_MENU_REQUEST, disableReportMenuSaga)
}
